import { useNavigate, useLocation, } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import Header from "../Components/Header";
import "./AdminProfile.css";
import { API_BASE, FILE_BASE } from "../config";

const AdminProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [twoFactor, setTwoFactor] = useState(false);
  const handleToggle = () => { setTwoFactor(!twoFactor); };

  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const [passwordData, setPasswordData] =
    useState({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });

  const [passwordLoading, setPasswordLoading] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);

  const [editData, setEditData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    profileImage: "",
  });

  const [editLoading, setEditLoading] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);

  // LOAD PROFILE
  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const token =
        localStorage.getItem("token");

      const response = await fetch(
        `${API_BASE}/admin-auth/profile`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          "Failed to fetch profile"
        );
      }

      const data = await response.json();

      setProfile(data);
    } catch (error) {
      console.error(error);

      alert("Failed to load profile");
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordInput = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangePassword = async () => {
    try {
      setPasswordLoading(true);

      const token =
        localStorage.getItem("token");

      const response = await fetch(
        `${API_BASE}/admin-auth/change-password`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",

            Authorization: `Bearer ${token}`,
          },

          body: JSON.stringify(passwordData),
        }
      );

      const result = await response.text();

      if (!response.ok) {
        throw new Error(result);
      }

      alert("Password changed successfully");

      setShowPasswordModal(false);

      setPasswordData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (error) {
      console.error(error);

      alert(error.message);
    } finally {
      setPasswordLoading(false);
    }
  };

  const handleEditInput = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdateProfile = async () => {
    try {
      setEditLoading(true);

      console.log(editData);

      const token =
        localStorage.getItem("token");

      const response = await fetch(
        `${API_BASE}/admin-auth/profile`,
        {
          method: "PUT",

          headers: {
            "Content-Type":
              "application/json",

            Authorization: `Bearer ${token}`,
          },

          body: JSON.stringify(editData),
        }
      );

      const result = await response.text();

      if (!response.ok) {
        throw new Error(result);
      }

      alert("Profile updated successfully");

      setShowEditModal(false);

      fetchProfile();
    } catch (error) {
      console.error(error);

      alert(error.message);
    } finally {
      setEditLoading(false);
    }
  };


  const handleImageUpload = async (file) => {
    try {
      const formData = new FormData();

      formData.append("file", file);

      const uploadResponse = await fetch(
        `${API_BASE}/upload`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!uploadResponse.ok) {
        throw new Error("Image upload failed");
      }

      const uploadData = await uploadResponse.json();

      const imageUrl = uploadData.imageUrl;

      setSelectedImage(imageUrl);

      // UPDATE UI IMMEDIATELY
      setProfile((prev) => ({
        ...prev,
        profileImage: imageUrl,
      }));

      // NOW SAVE TO DATABASE
      const token =
        localStorage.getItem("token");

      const response = await fetch(
        `${API_BASE}/admin-auth/profile`,
        {
          method: "PUT",

          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },

          body: JSON.stringify({
            name: profile?.name,
            email: profile?.email,
            phoneNumber:
              profile?.phoneNumber,
            profileImage: imageUrl,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(
          "Failed to save profile image"
        );
      }

      alert("Profile image updated");

    } catch (error) {
      console.error(error);

      alert(error.message);
    }
  };

  if (loading) {
    return (
      <div className="adminprofile-page">
        <Header />

        <div
          style={{ padding: "40px", textAlign: "center", }}>
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div className="adminprofile-page">
      <Header />

      {/* Top Title */}
      <div className="adminprofile-top">
        <h2>Admin Profile</h2>

        <p>
          Manage your account
          information
        </p>
      </div>

      {/* Profile Card */}
      <div className="adminprofile-card">
        <div className="adminprofile-banner"></div>

        <div className="adminprofile-content">
          <div
            className="adminprofile-avatar"
            onClick={() =>
              fileInputRef.current.click()
            }
            style={{
              cursor: "pointer",
              overflow: "hidden",
              position: "relative",
            }}
          >
            {(selectedImage ||
              profile?.profileImage) ? (
              <img
                src={
                  selectedImage ||
                  profile?.profileImage
                }
                alt="Profile"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="70"
                height="70"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M19 21V19C19 17.9391 18.5786 16.9217 17.8284 16.1716C17.0783 15.4214 16.0609 15 15 15H9C7.93913 15 6.92172 15.4214 6.17157 16.1716C5.42143 16.9217 5 17.9391 5 19V21"
                  stroke="#fff"
                  strokeWidth="2"
                />

                <path
                  d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                  stroke="#fff"
                  strokeWidth="2"
                />
              </svg>
            )}

            {/* CAMERA OVERLAY */}
            <div
              style={{
                position: "absolute",
                bottom: "0",
                right: "0",
                background: "#000000aa",
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="#fff"
                viewBox="0 0 24 24"
              >
                <path d="M9 3L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5H16.83L15 3H9ZM12 18C9.24 18 7 15.76 7 13C7 10.24 9.24 8 12 8C14.76 8 17 10.24 17 13C17 15.76 14.76 18 12 18ZM12 16C13.66 16 15 14.66 15 13C15 11.34 13.66 10 12 10C10.34 10 9 11.34 9 13C9 14.66 10.34 16 12 16Z" />
              </svg>
            </div>

            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={(e) => {
                const file = e.target.files[0];

                if (file) {
                  handleImageUpload(file);
                }
              }}
            />
          </div>

          <button
            className="adminprofile-edit-btn"
            onClick={() => {
              setEditData({
                name: profile?.name || "",
                email: profile?.email || "",
                phoneNumber:
                  profile?.phoneNumber || "",
                profileImage:
                  profile?.profileImage || "",
              });

              setSelectedImage(
                profile?.profileImage || ""
              );

              setShowEditModal(true);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#FFFFFF"
            >
              <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z" />
            </svg>

            Edit Profile
          </button>

          <div className="adminprofile-user">
            <h2>
              {profile?.name}
            </h2>

            <p>
              {profile?.role}
            </p>
          </div>

          <div className="adminprofile-grid">
            {/* EMAIL */}
            <div className="adminprofile-box">
              <div className="adminprofile-icon red">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#8B1A10"
                >
                  <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" />
                </svg>
              </div>

              <div>
                <span>
                  Email Address
                </span>

                <h4>
                  {profile?.email}
                </h4>
              </div>
            </div>

            {/* ROLE */}
            <div className="adminprofile-box">
              <div className="adminprofile-icon gold">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M20 13.0004C20 18.0004 16.5 20.5005 12.34 21.9505C12.1222 22.0243 11.8855 22.0207 11.67 21.9405C7.5 20.5005 4 18.0004 4 13.0004V6.00045C4 5.73523 4.10536 5.48088 4.29289 5.29334C4.48043 5.10581 4.73478 5.00045 5 5.00045C7 5.00045 9.5 3.80045 11.24 2.28045C11.4519 2.09945 11.7214 2 12 2C12.2786 2 12.5481 2.09945 12.76 2.28045C14.51 3.81045 17 5.00045 19 5.00045C19.2652 5.00045 19.5196 5.10581 19.7071 5.29334C19.8946 5.48088 20 5.73523 20 6.00045V13.0004Z"
                    stroke="#D4AF37"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <div>
                <span>Role</span>

                <h4>
                  {profile?.role}
                </h4>
              </div>
            </div>

            {/* STATUS */}
            <div className="adminprofile-box active">
              <div className="adminprofile-icon purple">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19 21V19C19 17.9391 18.5786 16.9217 17.8284 16.1716C17.0783 15.4214 16.0609 15 15 15H9C7.93913 15 6.92172 15.4214 6.17157 16.1716C5.42143 16.9217 5 17.9391 5 19V21"
                    stroke="#9810FA"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                    stroke="#9810FA"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <div>
                <span>Status</span>

                <h4>
                  {profile?.isActive
                    ? "Active"
                    : "Inactive"}
                </h4>
              </div>
            </div>

            {/* USER ID */}
            <div className="adminprofile-box active">
              <div className="adminprofile-icon purple">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19 21V19C19 17.9391 18.5786 16.9217 17.8284 16.1716C17.0783 15.4214 16.0609 15 15 15H9C7.93913 15 6.92172 15.4214 6.17157 16.1716C5.42143 16.9217 5 17.9391 5 19V21"
                    stroke="#9810FA"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                    stroke="#9810FA"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <div>
                <span>User ID</span>

                <h4>
                  #ADM-
                  {profile?.id}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Security */}
      <div className="adminprofile-security">
        <h2>Security Settings</h2>

        {/* CHANGE PASSWORD */}
        <div className="adminprofile-security-box">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
            }}
          >
            <div className="adminprofile-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M15.8333 9.16699H4.16667C3.24619 9.16699 2.5 9.91318 2.5 10.8337V16.667C2.5 17.5875 3.24619 18.3337 4.16667 18.3337H15.8333C16.7538 18.3337 17.5 17.5875 17.5 16.667V10.8337C17.5 9.91318 16.7538 9.16699 15.8333 9.16699Z"
                  stroke="#9E9E9E"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />

                <path
                  d="M5.83337 9.16699V5.83366C5.83337 4.72859 6.27236 3.66878 7.05376 2.88738C7.83516 2.10598 8.89497 1.66699 10 1.66699C11.1051 1.66699 12.1649 2.10598 12.9463 2.88738C13.7277 3.66878 14.1667 4.72859 14.1667 5.83366V9.16699"
                  stroke="#9E9E9E"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <div>
              <h4>
                Change Password
              </h4>

              <p>
                Update your password
                to keep your account
                secure
              </p>
            </div>
          </div>

          <button
            onClick={() =>
              setShowPasswordModal(true)
            }
          >
            Change
          </button>
        </div>
      </div>

      {showPasswordModal && (
        <div className="contentsettings-overlay">
          <div className="contentsettings-modal">
            <h3>Change Password</h3>

            <input
              type="password"
              name="currentPassword"
              placeholder="Current Password"
              className="contentsettings-input"
              value={
                passwordData.currentPassword
              }
              onChange={handlePasswordInput}
              style={{ marginTop: "20px" }}
            />

            <input
              type="password"
              name="newPassword"
              placeholder="New Password"
              className="contentsettings-input"
              value={passwordData.newPassword}
              onChange={handlePasswordInput}
              style={{ marginTop: "14px" }}
            />

            <input
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password"
              className="contentsettings-input"
              value={
                passwordData.confirmPassword
              }
              onChange={handlePasswordInput}
              style={{ marginTop: "14px" }}
            />

            <div
              style={{
                display: "flex",
                gap: "12px",
                marginTop: "20px",
                justifyContent: "center",
              }}
            >
              <button
                className="contentsettings-save-btn"
                onClick={handleChangePassword}
                disabled={passwordLoading}
              >
                {passwordLoading
                  ? "Updating..."
                  : "Update Password"}
              </button>

              <button
                className="contentsettings-save-btn"
                style={{
                  background: "#ddd",
                  color: "#000",
                }}
                onClick={() =>
                  setShowPasswordModal(false)
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}


      {/* EDIT PROFILE MODAL */}
      {showEditModal && (
        <div className="contentsettings-overlay">
          <div className="contentsettings-modal">
            <h3>Edit Profile</h3>

            <input
              type="text"
              name="name"
              placeholder="Full Name"
              className="contentsettings-input"
              value={editData.name}
              onChange={handleEditInput}
              style={{ marginTop: "20px" }}
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              className="contentsettings-input"
              value={editData.email}
              onChange={handleEditInput}
              style={{ marginTop: "14px" }}
            />

            <input
              type="text"
              name="phoneNumber"
              placeholder="Phone Number"
              className="contentsettings-input"
              value={editData.phoneNumber}
              onChange={handleEditInput}
              style={{ marginTop: "14px" }}
            />

            <div
              style={{
                display: "flex",
                gap: "12px",
                marginTop: "20px",
                justifyContent: "center",
              }}
            >
              <button
                className="contentsettings-save-btn"
                onClick={handleUpdateProfile}
                disabled={editLoading}
              >
                {editLoading
                  ? "Updating..."
                  : "Update Profile"}
              </button>

              <button
                className="contentsettings-save-btn"
                style={{
                  background: "#ddd",
                  color: "#000",
                }}
                onClick={() =>
                  setShowEditModal(false)
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminProfile;